import {
  collection, addDoc, updateDoc, deleteDoc,
  doc, getDocs, query, orderBy, onSnapshot,
} from 'firebase/firestore';
import { db } from './config';

const COL = 'products';

export const subscribeToProducts = (callback) => {
  const q = query(collection(db, COL), orderBy('name', 'asc'));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
};

export const getProducts = async () => {
  try {
    const q = query(collection(db, COL), orderBy('name', 'asc'));
    const snap = await getDocs(q);
    return { success: true, data: snap.docs.map((d) => ({ id: d.id, ...d.data() })) };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export const addProduct = async (data) => {
  try {
    const ref = await addDoc(collection(db, COL), {
      ...data,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
    return { success: true, id: ref.id };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export const updateProduct = async (id, data) => {
  try {
    await updateDoc(doc(db, COL, id), { ...data, updatedAt: new Date().toISOString() });
    return { success: true };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export const deleteProduct = async (id) => {
  try {
    await deleteDoc(doc(db, COL, id));
    return { success: true };
  } catch (e) {
    return { success: false, error: e.message };
  }
};
